import { AddButton } from '@core/components/Buttons';
import { TableActionButtonDelete, TableActionContainer } from '@core/components/TableAction';
import { Grid, List, ListItem, Typography } from '@material-ui/core';
import SelectEmpresa from 'app/components/Select/SelectEmpresa';
import { simpleAlert } from 'app/services/alerts';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';

const TabAcessoPorEmpresa = ({ usuarioLogado }) => {
  const formik = useFormikContext();
  const [empresasRetorno, setEmpresasRetorno] = useState([]);
  const [disableOptions, setDisableOptions] = useState(false);

  const _errors = {
    selectedEmpresa: (formik.submitCount || formik.touched?.selectedEmpresa) && formik.errors?.selectedEmpresa,
  };

  const handleAddEmpresa = () => {
    let novasEmpresas = [];

    if (formik?.values?.selectedEmpresa?.some((empresa) => empresa?.id === 'TODAS')) {
      const todasEmpresas = empresasRetorno?.filter((empresa) => empresa?.id !== 'TODAS');
      novasEmpresas = [...todasEmpresas];
    } else {
      if (formik?.values?.empresas?.length !== 0) {
        const empresasParaAdicionar = formik?.values?.selectedEmpresa?.filter((empresa) => {
          return !formik?.values?.empresas?.some((emp) => emp?.pessoa?.id === empresa?.pessoa?.id);
        });
        novasEmpresas = [...formik?.values?.empresas, ...empresasParaAdicionar];
      } else {
        novasEmpresas = [...formik?.values?.selectedEmpresa];
      }
    }

    formik.setFieldValue('empresas', novasEmpresas);
    formik.setFieldValue('selectedEmpresa', []);
    setDisableOptions(false);
  };

  const handleRemoveEmpresa = (idEmpresa) => {
    const empresaIdContexto = getEmpresaContexto();

    if (idEmpresa === empresaIdContexto && usuarioLogado?.id === formik.values?.id) {
      simpleAlert({
        opcoes: {
          title:
            'Não é possível remover o vínculo da empresa enquanto ela estiver sendo usada no contexto atual. Realize a troca para outra empresa.',
        },
      });
    } else {
      let listaAtualizada = formik?.values?.empresas?.filter((empresa) => empresa.id !== idEmpresa);
      formik.setFieldValue('empresas', listaAtualizada);
    }
  };

  const Head = ({ title }) => {
    return (
      <Grid item xl={12} style={{ background: '#e2e0e0', padding: 10 }}>
        <Typography style={{ fontWeight: 700, textTransform: 'none', fontSize: 16 }} variant="button">
          {title}
        </Typography>
      </Grid>
    );
  };

  const Body = ({ empresa, index }) => {
    const backgroundColor = index % 2 !== 0 ? '#e2e0e0' : '#fff';
    return (
      <ListItem
        key={empresa?.id}
        style={{ padding: 10, background: backgroundColor, display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography variant="body2">{empresa?.pessoa?.nome}</Typography>
        <TableActionContainer>
          <TableActionButtonDelete
            onClick={() => {
              handleRemoveEmpresa(empresa?.id);
            }}
          />
        </TableActionContainer>
      </ListItem>
    );
  };

  const returnData = (data) => {
    setEmpresasRetorno(data);
  };

  return (
    <Grid container spacing={3} className="mb-16">
      <Grid item xs={10}>
        <SelectEmpresa
          id="selectedEmpresa"
          name="selectedEmpresa"
          label="Vincular empresa"
          value={formik.values?.selectedEmpresa}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          multiple
          required
          touched={!!_errors.selectedEmpresa}
          error={_errors.selectedEmpresa}
          returnData={returnData}
          disableOptions={disableOptions}
          setDisableOptions={setDisableOptions}
        />
      </Grid>
      <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <AddButton
          capitalize={false}
          cor={'#43a047'}
          width={150}
          onClick={() => {
            handleAddEmpresa();
          }}
        >
          Adicionar
        </AddButton>
      </Grid>

      <Grid item xs={12}>
        <Head title="Empresas vinculadas" />
        {formik?.values?.empresas?.length > 0 &&
          formik?.values?.empresas
            ?.filter((empresa) => empresa?.ativo)
            ?.sort((atual, prox) => atual.pessoa?.nome.localeCompare(prox.pessoa?.nome))
            .map((empresa, index) => {
              return (
                <List key={empresa?.id} component="nav" style={{ paddingTop: 0 }}>
                  <Body empresa={empresa} index={index} />
                </List>
              );
            })}
      </Grid>
    </Grid>
  );
};

export default TabAcessoPorEmpresa;
